<template>
    <div>
        <action-bar>
            <router-link :to="{name: 'project-create'}">Neues Projekt erstellen</router-link>
        </action-bar>
        <main class="content">
            <h1>Projekte</h1>
            <project-list :projects="projects" v-if="projects" type="normal"></project-list>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
export default {
  asyncComputed: {
    projects() {
      let test = store.state.language;
      return axios
        .get("/api/" + store.state.language + "/project/list")
        .then(({ data }) => data.result);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/project/List.vue